import "./drinkmenu.css";
import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";

function RevealOnScroll({ children, delay = 0 }) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-50px" });

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 10 }}
      animate={isInView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.6, ease: "easeOut", delay }}
    >
      {children}
    </motion.div>
  );
}

function DrinkMenu() {
  const pageVariants = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0, transition: { duration: 1 } },
    exit: { opacity: 0, y: -20, transition: { duration: 1 } },
  };
  return (
    <motion.div
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
    >
      <div className="foodmenu-container">
        <img
          src="https://i.imgur.com/JluCMPd.jpeg"
          alt=""
          className="food-menu-hero"
        />
        <h1 className="food-menu-header">DRINK MENU</h1>
      </div>
      <div className="food-menu-items-container">
        {/* CATEGORY */}
        <div className="category">
          <RevealOnScroll>
            <div className="drinkitem-container">
              <h4 className="item-name">Drip Coffee</h4>
              <p className="item-price">$2.5 / 3</p>
            </div>
          </RevealOnScroll>
          <RevealOnScroll>
            <div className="drinkitem-container">
              <h4 className="item-name">Americano</h4>
              <p className="item-price">$4.5 / 5</p>
            </div>
          </RevealOnScroll>
          <RevealOnScroll>
            <div className="drinkitem-container">
              <h4 className="item-name">Espresso</h4>
              <p className="item-price">$2.5 / 3</p>
            </div>
          </RevealOnScroll>
          <RevealOnScroll>
            <div className="drinkitem-container">
              <h4 className="item-name">Latte</h4>
              <p className="item-price">$5 / 5.5</p>
            </div>
          </RevealOnScroll>
          <RevealOnScroll>
            <div className="drinkitem-container">
              <h4 className="item-name">Cappuccino</h4>
              <p className="item-price">$5 / 5.5</p>
            </div>
          </RevealOnScroll>
          <RevealOnScroll>
            <div className="drinkitem-container">
              <h4 className="item-name">Flat White</h4>
              <p className="item-price">$4</p>
            </div>
          </RevealOnScroll>
          <RevealOnScroll>
            <div className="drinkitem-container">
              <h4 className="item-name">Cortado</h4>
              <p className="item-price">$4</p>
            </div>
          </RevealOnScroll>
          <RevealOnScroll>
            <div className="drinkitem-container">
              <h4 className="item-name">Iced Coffee</h4>
              <p className="item-price">$3.5 / $4</p>
            </div>
          </RevealOnScroll>
          <RevealOnScroll>
            <div className="drinkitem-container">
              <h4 className="item-name">
                Hot Tea (Earl Grey, English Breakfast, Green Tea, Lemon Ginger,
                Peppermint)
              </h4>
              <p className="item-price">$3.5 / $4</p>
            </div>
          </RevealOnScroll>
          <RevealOnScroll>
            <div className="drinkitem-container">
              <h4 className="item-name">
                Iced Tea (Hibuscus , Black tea, Greean Tea, Peach Black Tea)
              </h4>
              <p className="item-price">$3.5 / $4</p>
            </div>
          </RevealOnScroll>
        </div>
        <div className="category">
          <RevealOnScroll>
            <h2 className="category-header">SPECIAL DRINKS</h2>
          </RevealOnScroll>
          <RevealOnScroll>
            <div className="drinkitem-container">
              <h4 className="item-name">Pistachio Latte</h4>
              <p className="item-price">$6/6.5</p>
            </div>
          </RevealOnScroll>
          <RevealOnScroll>
            <div className="drinkitem-container">
              <h4 className="item-name">Rose Latte</h4>
              <p className="item-price">$6/6.5</p>
            </div>
          </RevealOnScroll>
          <RevealOnScroll>
            <div className="drinkitem-container">
              <h4 className="item-name">Turkish Coffee</h4>
              <p className="item-price">$7</p>
            </div>
          </RevealOnScroll>
          <RevealOnScroll>
            <div className="drinkitem-container">
              <h4 className="item-name">Cold Brew</h4>
              <p className="item-price">$6.5/7</p>
            </div>
          </RevealOnScroll>
          <RevealOnScroll>
            <div className="drinkitem-container">
              <h4 className="item-name">Matcha Latte</h4>
              <p className="item-price">$5.5/6.5</p>
            </div>
          </RevealOnScroll>
          <RevealOnScroll>
            <div className="drinkitem-container">
              <h4 className="item-name">Chai Latte</h4>
              <p className="item-price">$5.5/6</p>
            </div>
          </RevealOnScroll>
        </div>
      </div>
    </motion.div>
  );
}

export default DrinkMenu;
